import React from 'react'
import { LoginStatus } from '@/components/layout'
import { SubSection, StyledDemoGrid, DemoComponent } from '../styled.jsx'

export const LoginStatusSection = () => {
  return (
    <>
      <SubSection
        title='Login Status (Mocked)'
        description='Two variants rendered based on user status. Routes are mocked for now.'
      >
        <StyledDemoGrid>
          <DemoComponent
            label='Logged in'
            component={
              <LoginStatus
                id='demo-login-status-in'
                donor={{ id: 1, first_name: 'John', last_name: 'Doe' }}
              />
            }
          />
          <DemoComponent
            label='Logged out'
            component={<LoginStatus id='demo-login-status-out' />}
          />
        </StyledDemoGrid>
      </SubSection>
    </>
  )
}
